import { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { ApiConfiguration } from '../config/ApiConfiguration';
import { ActivityLinks } from '../config/ActivityLinks';

export const useInvite = (invited) => {
    const [timeOfMount] = useState(new Date());
    const [accessId] = useState(uuidv4());

    const onUpdateRecord = (accessId, newRecord) => {
        return fetch(...ApiConfiguration.updateRecord(accessId, newRecord));
    };

    const getCurrentDuration = () => {
        return new Date() - timeOfMount;
    };

    const pingUpdate = setInterval(() => {
        onUpdateRecord(accessId, {timeSpent: getCurrentDuration()});
    }, 3000);

    const getLinkProps = (id) => ({
        timeOfMount,
        accessId,
        onUpdateRecord,
        ...ActivityLinks[id],
    });

    const createRecord = () => {
        const date = (new Date()).toISOString();
        fetch(...ApiConfiguration.createRecord(
            accessId, 
            invited, 
            date, 
            navigator.userAgent, 
            window.innerHeight, 
            window.innerWidth
        ));
    };

    const handleUpdatePings = () => {
        return () => clearInterval(pingUpdate);
    };

    return {
        accessId, 
        pingUpdate,
        getLinkProps,
        createRecord,
        handleUpdatePings,
    };
};